import { render, staticRenderFns } from "./CommentsEdit.vue?vue&type=template&id=0dfc5f4a&"
import script from "./CommentsEdit.vue?vue&type=script&lang=js&"
export * from "./CommentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommentsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports